import { useCallback, useState } from 'react';
import { useApi } from './useApi';

export enum FoodListType {
  allergens = 'allergens',
  dietary_restrictions = 'dietary_restrictions',
  avoided_foods = 'avoided_foods',
  other_diets = 'other_diets',
}

export type FoodItem = {
  ayble_id: number;
  stable_string: string;
  display_name: string;
  sift_tag_id: number | undefined;
};

export type AllFoodsList = { [key in FoodListType]: FoodItem[] };

const API_ENDPOINT = '/user_selections';

export const useFoodList = () => {
  const { api } = useApi();
  const [isFetchingFood, setIsFetchingFood] = useState(true);

  const getFoodList = useCallback(
    async ({ route }) => {
      setIsFetchingFood(true);

      const response: FoodItem[] = await api({
        route,
      });

      setIsFetchingFood(false);

      if (response) {
        return response;
      }
      return [];
    },
    [api]
  );

  const getAllFoods = useCallback(async () => {
    setIsFetchingFood(true);

    const response: AllFoodsList = await api({
      route: `${API_ENDPOINT}/all`,
    });

    setIsFetchingFood(false);

    if (response) {
      return response;
    }
    return {};
  }, [api]);

  const getAllergensFoods = useCallback(async () => {
    return getFoodList({
      route: `${API_ENDPOINT}/${FoodListType.allergens}`,
    });
  }, [getFoodList]);

  const getDietaryRestrictionsFoods = useCallback(async () => {
    return getFoodList({
      route: `${API_ENDPOINT}/${FoodListType.dietary_restrictions}`,
    });
  }, [getFoodList]);

  const getAvoidedFoods = useCallback(async () => {
    return getFoodList({
      route: `${API_ENDPOINT}/${FoodListType.avoided_foods}`,
    });
  }, [getFoodList]);

  const getOtherDietsFoods = useCallback(async () => {
    return getFoodList({
      route: `${API_ENDPOINT}/${FoodListType.other_diets}`,
    });
  }, [getFoodList]);

  return {
    getAllFoods,
    getAllergensFoods,
    getDietaryRestrictionsFoods,
    getAvoidedFoods,
    getOtherDietsFoods,
    isFetchingFood,
  };
};
